/**
 * The only point of this component is to assist writing tests where you want to be able to validate that an element is not present. Sometimes it's hard to tell
 * the difference between "data not loaded yet" vs. "data loaded but nothing to show". Using this component, you can:
 *
 * ```tsx
 * if (!data) {
 *   return false;
 * }
 *
 * if (!data.length) {
 *   return <Null data-testid='no-data' />
 * }
 *
 * return data.map(...);
 * ```
 */
export const Null = (props: { 'data-testid': string }) => {
    if (process.env.NODE_ENV === 'production') return null;

    return <span style={{ display: 'none' }} {...props}></span>;
};
